export default {
  itemsPerPage: [
    {
      value: 10
    },
    {
      value: 50
    },
    {
      value: 100
    },
    {
      value: 200
    }
  ]
}



// WEBPACK FOOTER //
// ./src/vuestic-theme/vuestic-components/vuestic-datatable/data/items-per-page-definition.js